import React, { Component } from 'react';
import Tooltip from 'react-tooltip-lite';
import './SelectionBox.css'
import '../Tooltip.css';

export default class SelectionBox extends Component {
    constructor(props) {
        super(props);
        // this.handleChange = this.handleChange.bind(this);
        this.state = {};
    }
    handleChange = (e) => {
        this.props.onChange(e.target.name, e.target.value, e.target.checked);
    }
    render() {
        return (
            <div className={"SelectionBox" + (this.props.type!==undefined?(" "+this.props.type):"") + (this.props.extrawidth!==undefined?(" "+this.props.extrawidth):"")}>
                <label className="name"><input type="checkbox" name={this.props.name} value={this.props.value} checked={this.props.ischecked} onChange={this.handleChange}/>{this.props.tooltip && <Tooltip styles={{whiteSpace: "pre"}} tagName="span" content={this.props.tooltip} direction="down-start" arrow={false}>{this.props.label}</Tooltip>}{!this.props.tooltip && this.props.label} {this.props.count>-1 && <span className="count">({this.props.count})</span>}<span className="checkmark"/></label>
            </div>
        );
    }
}